/*
	Generated on 12/05/2025 by UI Generator PRICES-IDE
	https://amanah.cs.ui.ac.id/research/ifml-regen
	version 3.10.0
*/
import React from "react";
import { Controller, useForm } from "react-hook-form";
import { useNavigate, useSearchParams } from "react-router";
import {
  Button,
  Form,
  SelectionField,
  MultiSelectionField,
  InputField,
  MultiSelectField,
  RadioInputField,
  TextAreaField,
  RichTextField,
  VisualizationAttr,
  Spinner,
  
  
} from "@/commons/components";
import {
  ALLOWED_PERMISSIONS,
  findAllowedPermission,
} from "@/commons/constants/allowedPermission";
import cleanFormData from "@/commons/utils/cleanFormData";
import updateJadwalKelas from '../services/updateJadwalKelas'

import { notifyError, notifySuccess} from "@/commons/utils/toaster";
import * as Layouts from "@/commons/layouts";

const FormUbahJadwalKelas = ({ 
	jadwalKelasData
, 	ruangan
, 	hari
 }) => {
  const { 
    control, 
    handleSubmit,
  } = useForm({ defaultValues: jadwalKelasData })
  
  
  
  
  const navigate = useNavigate()
  
  const simpan = (data) => {
    const cleanData = cleanFormData(data)
    updateJadwalKelas({
      ...cleanData,
    })
    .then(({ data: { data } }) => {
     navigate(`/kelas/${jadwalKelasData.kelasId}`)
  	notifySuccess(`Update Jadwal Kelas berhasil!`);
    })
    .catch((error) => {
      console.error(error);
          notifyError(error);
    });
  }
  
  
  return (
	<div>
	  <Layouts.FormComponentLayout
		  title="Ubah Jadwal Kelas" 
		  onSubmit={handleSubmit(simpan)}
	
	    vas={[
		  ]}
	
		  formFields={[
			  
			  <Controller
			    key="mulai"
		        name="mulai"
		        control={control}
		        render={({ field, fieldState }) => (
				  <InputField
				    type="time"
		            label="Waktu Mulai"
		            placeholder="Masukkan waktu mulai"
		            defaultValue={jadwalKelasData.mulai}	            fieldState={fieldState}
					{...field}
					isRequired={false}
		          />
		        )}
		      />
	,
			  
			  <Controller
			    key="selesai"
		        name="selesai"
		        control={control}
		        render={({ field, fieldState }) => (
				  <InputField
				    type="time"
		            label="Waktu Selesai"
		            placeholder="Masukkan waktu selesai"
		            defaultValue={jadwalKelasData.selesai}	            fieldState={fieldState}
					{...field}
					isRequired={false}
		          />
		        )}
		      />
		  ,
	
		  
		  <Controller
		    key="ruanganId"
	        name="ruanganId"
	        control={control}
	        render={({ field, fieldState }) => (
					<SelectionField
				
	            label="Ruangan"
	            options={ruangan}
				optionKey="ruanganId"
	            optionLabel="ruangan"
	            placeholder="Masukkan ruangan"
					fieldState={fieldState}
					defaultValue={jadwalKelasData.ruanganId}
	            {...field}
					isRequired={false}
	          />
	
	        )}
	      />
	,
		  
		  <Controller
		    key="hari"
	        name="hari"
	        control={control}
	        render={({ field, fieldState }) => (
					<SelectionField
				
	            label="Hari"
	            options={hari}
				optionKey="hari"
	            optionLabel="hari"
	            placeholder="Masukkan hari"
					fieldState={fieldState}
					defaultValue={jadwalKelasData.hari}
	            {...field}
					isRequired={false}
	          />
	
	        )}
	      />
		  ]}
	
		  itemsEvents={[
				<Button id="_kwRFUCwoEfCoct7gkgY0lg" key="Simpan" type="submit" variant="primary">Simpan</Button>
	    ]}
	  />
	    
	</div>
  )
}

export default FormUbahJadwalKelas
